module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("List of Maps")])])]), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }, [_c('p', {
    staticClass: "list"
  }, [_vm._v("A map from Blaxland’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Destination Dunkirk")]), _vm._v(", illustrating the BEF withdrawal to the coast")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A sketch map showing the position of Gort’s Headquarters and the Post Office at La Panne")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("Three maps from Hans-Adolf Jacobsen’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dünkirchen")]), _vm._v(" depicting the contracting perimeter")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A sketch map of the Nieuport Bridges from the 13/Field Survey Unit War Diary")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map from the 7/Field Regiment War diary depicting the deployment of BEF and French divisions between La Panne and Nieuport")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map drawn by Second Lieutenant Robin Medley illustrating the two positions occupied by his platoon at Oost-Dunkerque")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map from the DCLI War Diary showing the positions of the three infantry brigades of the 4"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("th")]), _vm._v(" Division")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dunkirk")]), _vm._v(" by Robert Jackson showing the Dunkerque Perimeter on 30 May, depicting the British, French and German forces")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map illustrating the positions occupied by the 1"), _c('sup', {
    staticClass: "sup"
  }, [_vm._v("st")]), _vm._v(" Battalion Duke of Wellington’s Regiment")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map from "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dunkirk")]), _vm._v(" by Robert Jackson illustrating the reduced perimeter after the II Corps sector had been abandoned")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of the Loyal North Lancashire Regiment")])]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map of the Dunkerque harbour area, showing Bastion 32 and the Royal Naval dugout")]), _vm._v(" "), _c('p', {
    staticClass: "list"
  }, [_vm._v("A map of Nieuwpoort as it is today")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff68267a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Maps.vue
// module id = 72
// module chunks = 0